    export type geoMarker = {
        
                "Id": any,
                "Typ": string,
                "RevierId": string,
                "RevierNummer": number,
                "RevierName": string,
                "Symbol": string,
                "Farbe": string,
                "Size": string,
                "X_Koordinate": number,
                "Y_Koordinate": number,
                "InfoText": string
    }

    export type GeoCoordinates = {
        latitude: number 
        longitude: number
    }
    
    export enum GpsState {
        PermissionDenied,
        NetworkDown,
        LocationTimeout,
        PositionDelivered,
        GeneralError    
    }